const Window = window as any;

const globalConfig = {
  apiBaseUrl: Window["runConfig"]["apiUrl"],
  chatAppId: Window["runConfig"]["tencentImAppId"],
  apiKey: Window["runConfig"]["googleMapsApiKey"],
};

export default globalConfig;
